import React, { useEffect, useState } from "react";
import { Breadcrumb, Button, Form } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { BiChevronsLeft } from "react-icons/bi";
import ESGDataSetService from "../../../core/service/ESGDataSetService";
import ESGStandards from "../Standard/ESGStandards";
import './PlatformCodeMapping.scss';
import StdCodeSelectionPane from "./StdCodeSelectionPane";

const PlatformCodeMapping = ({ t }) => {

	const [standards, setStandards] = useState([]);
	const [standardToMap, setStandardToMap] =  useState('');
	const [selectedMetric, setSelectedMetric] = useState({ code: '', action: ''});
	const [mappedCodes, setMappedCodes] = useState([]);
	const [selectedDP, setSelectedDP] = useState({ code: '', action: ''});
	const [selectedGDQ, setSelectedGDQ] = useState({ code: '', action: ''});
	const [selectedQualQues, setSelectedQualQues] = useState({ code: '', action: ''});

	useEffect(() => {
		getStandards();
	}, []);

	const getStandards = () => {
		ESGDataSetService.getPlatformStandard().then(res => {
			if (res.status !== 200) return;

			setStandards(res.data.data);
			setStandardToMap(res.data.data[0] ?? '');
		}).catch(err => {});
	};

	const mapMetric = (m) => {
		setSelectedMetric({ code: m.code, action: 'EDIT'});
		if (mappedCodes.length > 0 ) {
			setMappedCodes([]);
		}
		setSelectedDP({ code: '', action: ''});
		setSelectedGDQ({ code: '', action: ''});
		setSelectedQualQues({ code: '', action: ''});
	};

	const deleteMetricMapping = (m) => {
		setSelectedMetric({ code: '', action: 'DELETE'});
		setMappedCodes([]);
		if (mappedCodes.length > 0 ) {
			setMappedCodes([]);
		}
		setSelectedDP({ code: '', action: ''});
		setSelectedGDQ({ code: '', action: ''});
		setSelectedQualQues({ code: '', action: ''});
	};

	const mapDP = (dp) => {
		setSelectedDP({ code: dp.code, action: 'EDIT'});
		if (mappedCodes.length > 0 ) {
			setMappedCodes([]);
		}
		setSelectedMetric({ code: '', action: ''});
		setSelectedGDQ({ code: '', action: ''});
		setSelectedQualQues({ code: '', action: ''});
	};

	const deleteDPMapping = (dp) => {
		setSelectedDP({ code: '', action: 'DELETE'});
		setMappedCodes([]);
		if (mappedCodes.length > 0 ) {
			setMappedCodes([]);
		}
		setSelectedMetric({ code: '', action: ''});
		setSelectedGDQ({ code: '', action: ''});
		setSelectedQualQues({ code: '', action: ''});
	};


	const mapGDQ = (q) => {
		setSelectedGDQ({ code: q.code, action: 'EDIT'});
		if (mappedCodes.length > 0 ) {
			setMappedCodes([]);
		}
		setSelectedMetric({ code: '', action: ''});
		setSelectedDP({ code: '', action: ''});
		setSelectedQualQues({ code: '', action: ''});
	};

	const deleteGDQMapping = (q) => {
		setSelectedGDQ({ code: '', action: 'DELETE'});
		setMappedCodes([]);
		if (mappedCodes.length > 0 ) {
			setMappedCodes([]);
		}
		setSelectedMetric({ code: '', action: ''});
		setSelectedDP({ code: '', action: ''});
		setSelectedQualQues({ code: '', action: ''});
	};

	const mapQualQuestion = (q) => {
		setSelectedQualQues({ code: q.code, action: 'EDIT'});
		if (mappedCodes.length > 0 ) {
			setMappedCodes([]);
		}
		setSelectedMetric({ code: '', action: ''});
		setSelectedDP({ code: '', action: ''});
		setSelectedGDQ({ code: '', action: ''});
	};

	const deleteQualQuestionMapping = (q) => {
		setSelectedQualQues({ code: '', action: 'DELETE'});
		setMappedCodes([]);
		if (mappedCodes.length > 0 ) {
			setMappedCodes([]);
		}
		setSelectedMetric({ code: '', action: ''});
		setSelectedDP({ code: '', action: ''});
		setSelectedGDQ({ code: '', action: ''});
	};


	return (
		<div className="CodeMapping">
			<div className="List_header">
				<Breadcrumb className="h5">
					<Breadcrumb.Item href="#">{t("ESGDataset.label")}</Breadcrumb.Item>
					<Breadcrumb.Item active>{t('PlatCodeMapping.label')}</Breadcrumb.Item>
				</Breadcrumb>

			</div>
			<div className="row m-0">
				<div className="col-lg-12 p-2 select_mapStandard">
					<div className="select_mapStandard_inner">
						{t('MapCodeWith.label')}
						<Form.Select size="sm" className="w-auto ms-2" 
						 onChange={(e) => setStandardToMap(e.target.value)}
						 selected={standardToMap}>
							{
								standards?.map((s, index) => {
									return <option key={`std-${index}`} value={s}>{s}</option>
								})
							}
						</Form.Select>
					</div>
					<Button variant="secondary" size="sm"><BiChevronsLeft />{t('Back.label')}</Button>
				</div>
				<div className="EcodrisilStandards_card col-lg-8 p-2">
					<ESGStandards isMappingMode={true} 
						mappingStandards={standards}
						standardToMap={standardToMap}
						onMapMetric={(m) => mapMetric(m)}
						onDeleteMetricMapping={(m) => deleteMetricMapping(m)}
						onMapDP={(dp) => mapDP(dp)}
						onDeleteDPMapping={(dp) => deleteDPMapping(dp)}
						onMapGDQ={(q) => mapGDQ(q)}
						onDeleteGDQMapping={(q) => deleteGDQMapping(q)}
						onMapQualQuestion={(q) => mapQualQuestion(q)}
						onDeleteQualQuestionMapping={(q) => deleteQualQuestionMapping(q)}
						mappedCodes={mappedCodes}/>
				</div>
				<div className="Standards_mapping_card col-lg-4 p-2">
					<StdCodeSelectionPane standardToMap={standardToMap}
						platformCode={
							selectedMetric.code !== '' 
							? selectedMetric.code : selectedDP.code !== '' 
							? selectedDP.code : selectedGDQ.code !== '' 
							? selectedGDQ.code : selectedQualQues.code
						}
						onCodeChange={(codes) => setMappedCodes(codes)}/>
				</div>
			</div>
		</div>
	);

};
export default withTranslation()(PlatformCodeMapping);
